import React, { useContext, useEffect, useState } from 'react'
import { TabList, TabPanels, TabPanel } from '@reach/tabs'
import { Form } from 'react-final-form'
import arrayMutators from 'final-form-arrays'
import Layout from '../../components/Layout'
import { Tab, Tabs } from '../../components/Tabs'
import Heading from '../../components/Heading'
import { AppContext } from '../App'
import Button from '../../components/Button'
import closeIcon from '../../images/closeIcon-red.svg'
import addIcon from '../../images/addIcon.svg'
import List from './DiagnosisList'
import NewDiagnosis from './NewDiagnosis'
import withPermissions from '../../containers/withPermissions'
import PatientForm from './PatientForm'
import styled from 'styled-components'
import { useNotifications } from '../../containers/Notifications'
import { navigate } from 'gatsby'
import withLoading from '../../utils/withLoading'
import _ from 'lodash'

export const PATIENT_ENDPOINT = '/diagnostic/rest/patient'

const decorate = withPermissions

const PatientPage = ({ userRoles, location, ...props }) => {
  const {
    userId,
    withAuth,
    unitId,
    hiddenSchoolSection,
    onClickHideSchool,
    guardianAddress,
    onOpenGuardianAddressModal,
  } = useContext(AppContext)

  const id = location.pathname.substring(location.pathname.lastIndexOf('/') + 1)
  const { notify } = useNotifications()
  const LoadingPatientForm = withLoading(PatientForm)
  const [tabsReady, setTabsReady] = useState(false)
  const [diagnosis, setDiagnosis] = useState([])

  const [ready, setReady] = useState(false)
  const [patient, setPatient] = useState({
    pesel: '',
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    gender: '',
    disability: '',
    address: {
      street: '',
      city: '',
      postcode: '',
      voivodeship: '',
    },
    groupName: '',
    guardian: null,
    school: null,
  })

  const [params, setParams] = useState({
    sorts: {},
    meta: {
      limit: 10,
      page: 0,
      total: 0,
    },
  })

  const [isModalOpen, toggleModal] = useState(false)

  const [tabIndex, setTabIndex] = useState(0)

  const handleTabsChange = (index) => {
    setTabIndex(index)
  }

  const fetchDiagnosis = async () => {
    setReady(false)
    const endpoint = userRoles.includes('unitDirector')
      ? '/diagnostic/rest/examination/search'
      : '/diagnostic/rest/examination/my/search'

    const result = await withAuth(`${endpoint}`, {
      method: 'POST',
      payload: {
        filters: {
          patientId: props.id,
          unitId: unitId,
          ...(!userRoles.includes('unitDirector') && {
            diagnosticianId: userId,
          }),
        },
        meta: { ...params.meta },
      },
    })
    if (result !== undefined) {
      setDiagnosis(result.models)
      setParams({
        ...params,
        meta: { ...params.meta, total: result.meta.total },
      })
    } else return

    setReady(true)
  }

  const editPatient = async (values) => {
    const payloadToSend = {
      firstName: values.firstName,
      lastName: values.lastName,
      address: null,
      school: hiddenSchoolSection ? null : { ...values.school },
      guardian: null,
      targetDiagnosticianId: userId,
    }

    try {
      await withAuth(`${PATIENT_ENDPOINT}/${id}`, {
        method: 'PUT',
        payload: payloadToSend,
      })
      notify(`Dane osoby o ID ${id} zostały zaktualizowane.`, 'success')
    } catch (e) {}
  }

  useEffect(() => {
    const fetchData = async () => {
      setTabsReady(false)
      try {
        const result = await withAuth(`${PATIENT_ENDPOINT}/${id}`, {
          method: 'GET',
        })
        setPatient({
          pesel: '-',
          firstName: '-',
          lastName: '-',
          dateOfBirth: result.model.person.dateOfBirth,
          gender: result.model.person.gender,
          disability: result.model.disability,
          address: null,
          guardian: null,
          school:
            result.model.school === null
              ? onClickHideSchool()
              : {
                  ...result.model.school,
                },
        })
        setTabsReady(true)
      } catch (e) {
        if ((e.status = 403 && !userRoles.includes('diagnostician'))) {
          navigate('/app')
        } else if ((e.status = 403)) {
          navigate('/app/patients')
        }
      }
    }
    fetchData()
  }, [id, withAuth])

  useEffect(() => {
    fetchDiagnosis()
  }, [params.meta.page])

  return (
    <Form
      enableReinitialize={true}
      initialValues={patient}
      mutators={{
        ...arrayMutators,
      }}
      onSubmit={editPatient}
    >
      {({ handleSubmit }) => (
        <Layout>
          <Heading title={displayName(patient)} border={false}>
            <Button
              link="/app/patients"
              label="Powrót"
              color="white"
              icon={closeIcon}
              altTag=""
              imgAriaHidden={true}
            />
            <Button
              marginLeft
              label="Nowa diagnoza"
              icon={addIcon}
              onClick={() => toggleModal((prevState) => !prevState)}
              altTag=""
              imgAriaHidden={true}
            />
            {tabIndex === 0 && (
              <Button
                marginLeft
                label="Zaktualizuj dane osoby"
                icon={addIcon}
                onClick={handleSubmit}
                altTag=""
                imgAriaHidden={true}
              />
            )}
          </Heading>
          <Tabs index={tabIndex} onChange={handleTabsChange}>
            <TabList
              style={{
                borderBottom: '1px solid #e4e4e4',
              }}
            >
              <Tab>Dane Osobowe</Tab>
              <Tab>Lista diagnoz</Tab>
            </TabList>

            <TabPanels>
              <TabPanel>
                <FormPositioner>
                  <LoadingPatientForm
                    patient={patient}
                    editable={false}
                    onSubmit={handleSubmit}
                    ready={tabsReady}
                  />
                </FormPositioner>
              </TabPanel>

              <TabPanel>
                <List
                  {...props}
                  diagnosis={diagnosis}
                  setDiagnosis={setDiagnosis}
                  params={params}
                  setParams={setParams}
                  ready={ready}
                />
              </TabPanel>
            </TabPanels>
          </Tabs>
          <NewDiagnosis
            handleTabsChange={handleTabsChange}
            isOpen={isModalOpen}
            dateOfBirth={patient.dateOfBirth}
            onClose={() => toggleModal((prevState) => !prevState)}
            refetchData={fetchDiagnosis}
            id={props.id}
          />
        </Layout>
      )}
    </Form>
  )
}

const displayName = (patient) =>
  patient ? `${patient.firstName} ${patient.lastName}` : ''

export default decorate(PatientPage)

const FormPositioner = styled.div`
  display: flex;
`
